import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdentityService {

constructor(private http: HttpClient) { }


login(model: any) {
//  return Observable.create(observer => {
    //var res={token:"token",displayName:"Kutlu"};
return    this.http.post<any>(`${environment.apiUrl}identity/login`, model);
}

loginwithlink(model: any) {
//  return Observable.create(observer => {
    //var res={token:"token",displayName:"Kutlu"};
return    this.http.get<any>(`${environment.apiUrl}identity/loginwithlink?link=${model}`);
}

}
